import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../index.css";
import { billpunchbasicauth } from "../../utils/Credentials";
import { GlobalContext } from "../../Context/GlobalState";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";

const Manageloan = () => {
  const location = useLocation();
  const { employeename } = location.state || {};
  const { password, username } = billpunchbasicauth;
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const empid = location?.state?.empid || "";
  const [loanList, setLoanList] = useState([]);

  const Getloan = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const raw = JSON.stringify({
        firm_id: user.firm_id,
        empid: empid,
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/Getloan`,
        requestOptions
      );

      const data = await res.json();

      if (data.status === "0") {
        setLoanList(data.data);
      } else {
        setLoanList([]);
      }
    } catch (error) {
      console.log("error", error);
    }

    setTransactionLoaderState(false);
  };
  const UpdateLoan = async (loanId, status) => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const raw = JSON.stringify({
        loan_id: loanId,
        status: status,
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/Updateloan`,
        requestOptions
      );

      const data = await res.json();

      if (data.status === "0") {
        Getloan();
      } else {
        alert(data.msg);
      }
    } catch (error) {
      console.log(error);
    }

    setTransactionLoaderState(false);
  };
  useEffect(() => {
    Getloan();
  }, []);
  const formatMonthYear = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toLocaleString("default", { month: "short", year: "numeric" });
  };
  return (
    <div className="mt-4 m-3">
      <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
        <h5 className="m-0">Manage loan for {employeename}</h5>

        <div className="d-flex gap-2">
          <Link
            to="/admin/loan-management"
            className="btn btn-outline-primary btn-sm"
            style={{ borderRadius: "6px", padding: "4px 14px" }}
          >
            ← Back
          </Link>
        </div>
      </div>
      <div className="table-responsive">
        <table
          className="table table-sm align-middle mb-0"
          style={{ fontSize: "0.9rem" }}
        >
          <thead style={{ background: "#f1f3f5" }}>
            <tr>
              <th
                className="text-center"
                style={{ fontSize: ".9rem", fontWeight: "400" }}
              >
                Salary
              </th>
              <th
                className="text-center"
                style={{ fontSize: ".9rem", fontWeight: "400" }}
              >
                Loan Amount
              </th>
              <th
                className="text-center"
                style={{ fontSize: ".9rem", fontWeight: "400" }}
              >
                EMI Amount
              </th>
              <th
                className="text-center"
                style={{ fontSize: ".9rem", fontWeight: "400" }}
              >
                File Charge
              </th>
              <th
                className="text-center"
                style={{ fontSize: ".9rem", fontWeight: "400" }}
              >
                Loan Date
              </th>
              <th
                className="text-center"
                style={{ fontSize: ".9rem", fontWeight: "400" }}
              >
                Tenure
              </th>
              <th
                className="text-center"
                style={{ fontSize: ".9rem", fontWeight: "400" }}
              >
                Start 
              </th>
              <th
                className="text-center"
                style={{ fontSize: ".9rem", fontWeight: "400" }}
              >
                End 
              </th>
              <th
                className="text-center"
                style={{ fontSize: ".9rem", fontWeight: "400" }}
              >
                Status
              </th>
              <th
                className="text-center"
                style={{ fontSize: ".9rem", fontWeight: "400" }}
              >
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            {loanList.length > 0 ? (
              loanList.map((item) => (
                <React.Fragment key={item.id}>
                  <tr>
                    <td
                      style={{ fontSize: ".9rem" }}
                      className="text-primary fw-semibold text-center"
                    >
                      ₹{item.salary}
                    </td>
                    <td
                      style={{ fontSize: ".9rem" }}
                      className="fw-semibold text-center"
                    >
                      ₹{item.total_loan}
                    </td>
                    <td
                      style={{ fontSize: ".9rem" }}
                      className="fw-semibold text-center"
                    >
                      ₹{item.loan_emi_amount}
                    </td>
                    <td className="text-center" style={{ fontSize: ".9rem" }}>
                      ₹{item.loan_file_charge}
                    </td>
                    <td className="text-center" style={{ fontSize: ".9rem" }}>
                      {item.loan_disbursement_date?.split("T")[0]}
                    </td>
                    <td className="text-center" style={{ fontSize: ".9rem" }}>
                      <span className="badge bg-light text-dark border">
                        {item.emi_tenure} Month
                      </span>
                    </td>
                    <td style={{fontSize:".9rem"}}>{formatMonthYear(item.start_date)}</td>
                    <td style={{fontSize:".9rem"}}>{formatMonthYear(item.end_date)}</td>
                    <td className="text-center" style={{ fontSize: "1rem" }}>
                      {item.is_active === "P" ? (
                        <span className="badge bg-warning text-dark">
                          Pending for Approval
                        </span>
                      ) : item.is_active === "Y" ? (
                        <span className="badge bg-success">Approved</span>
                      ) : (
                        <span className="badge bg-danger">Rejected</span>
                      )}
                    </td>
                    <td className="text-center" style={{ fontSize: "1rem" }}>
  {item.is_active === "P" ? (
    <div className="d-flex justify-content-center gap-1">
      <button
        className="btn btn-outline-success btn-sm"
        style={{ padding: "2px 8px", fontSize: ".8rem" }}
        onClick={() => UpdateLoan(item.id, "Y")}
      >
        Approve
      </button>

      <button
        className="btn btn-outline-danger btn-sm"
        style={{ padding: "2px 8px", fontSize: ".8rem" }}
        onClick={() => UpdateLoan(item.id, "N")}
      >
        Reject
      </button>
    </div>
  ) : item.is_active === "Y" ? (
    <span className="badge bg-success">Approved</span>
  ) : (
    <span className="badge bg-danger">Rejected</span>
  )}
</td>
                  </tr>
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td colSpan="10" className="text-center py-4 text-muted">
                  No Loan Records Found for {employeename}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Manageloan;
